import Toggle from 'material-ui/Toggle';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { Entities } from 'src/common/index';
import composeModalActions from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import ErrorMessage from 'src/components/misc/error-message';
import ReviewCategoryEditModal from 'src/components/admin/reviewcategories/review-category-edit-modal';
import { withTranslation } from 'react-i18next';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { keysWithNonBlankValues } from 'src/components/misc/validations';
import { IconLabel } from 'src/components/administration/IconLabel';

class AdminReviewCategoryAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchAll(Entities.REVIEW_CATEGORY);
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { reviewCategories } = nextProps;

        if (reviewCategories.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(reviewCategories.items.length);
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.reviewCategories,
                this.props.reviewCategories,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { reviewCategories, t } = this.props;
        const finishFetching = this.state.startedFetching && !reviewCategories.isFetching;

        const tableData = [];
        if (finishFetching && reviewCategories.items.length > 0) {
            reviewCategories.items.map(reviewCategory => {
                tableData.push({
                    id: reviewCategory.id,
                    name: reviewCategory.name.de,
                    translated: keysWithNonBlankValues(reviewCategory.name),
                    active: reviewCategory.active,
                    position: reviewCategory.position,
                    factor: reviewCategory.factor,
                });
            });
        }

        return (
            <div>
                <legend className="legend">
                    {t('review_categories.categories')}
                    <button
                        className="btn btn-xs btn-blue pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: ReviewCategoryEditModal,
                                componentProps: {
                                    isCreate: true,
                                },
                                title: t('category.new_category'),
                                mandatoryFields: true,
                            });
                        }}>
                        <IconLabel icon="plus" text={t('category.new_category')} />
                    </button>
                </legend>

                {(() => {
                    if (reviewCategories.error) return <ErrorMessage object={reviewCategories} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        hidden={true}
                                        isKey={true}
                                        export={true}>
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                                        {t('common_phrases.name')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="translated"
                                        dataSort={true}>
                                        {t('cancellations.translated')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="factor"
                                        width="100"
                                        dataSort={true}>
                                        {t('review_categories.factor')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="position"
                                        width="100"
                                        dataSort={true}>
                                        {t('review_categories.position')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="active"
                                        dataSort={true}
                                        width="80"
                                        dataFormat={this.statusFormatter}>
                                        {t('common_phrases.active')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="actions"
                                        width="90"
                                        dataFormat={this.tableActionsFormatter}
                                        export={false}>
                                        {t('common_phrases.actions')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </div>
        );
    }

    statusFormatter(cell, reviewCategory) {
        return (
            <Toggle
                toggled={reviewCategory.active}
                onToggle={() =>
                    this.props.patch(
                        {
                            id: reviewCategory.id,
                            active: !reviewCategory.active,
                        },
                        Entities.REVIEW_CATEGORY,
                    )
                }
            />
        );
    }

    tableActionsFormatter(cell, reviewCategory) {
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.props.openModal({
                            component: ReviewCategoryEditModal,
                            componentProps: {
                                id: reviewCategory.id,
                                isCreate: false,
                            },
                            title: reviewCategory.name,
                            mandatoryFields: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(AdminReviewCategoryAdministration));
